const MAX_EMAIL_LENGTH = 254
const MAX_LOCAL_PART_LENGTH = 64

const isLocalPartChar = (code: number): boolean =>
  (code >= 48 && code <= 57) ||
  (code >= 65 && code <= 90) ||
  (code >= 97 && code <= 122) ||
  code === 46 ||
  code === 95 ||
  code === 45 ||
  code === 43

const isDomainChar = (code: number): boolean =>
  (code >= 48 && code <= 57) ||
  (code >= 65 && code <= 90) ||
  (code >= 97 && code <= 122) ||
  code === 46 ||
  code === 95 ||
  code === 45

export const isValidEmail = (value: string): boolean => {
  const email = value.trim()
  if (!email || email.length > MAX_EMAIL_LENGTH) return false
  if (email.includes(' ') || email.includes('\t') || email.includes('\n') || email.includes('\r')) {
    return false
  }

  const atIndex = email.indexOf('@')
  if (atIndex <= 0 || atIndex !== email.lastIndexOf('@')) return false

  const localPart = email.slice(0, atIndex)
  const domainPart = email.slice(atIndex + 1)
  if (!localPart || localPart.length > MAX_LOCAL_PART_LENGTH || !domainPart) return false

  const dotIndex = domainPart.indexOf('.')
  if (dotIndex <= 0 || dotIndex === domainPart.length - 1) return false

  for (let i = 0; i < localPart.length; i += 1) {
    if (!isLocalPartChar(localPart.charCodeAt(i))) return false
  }

  for (let i = 0; i < domainPart.length; i += 1) {
    const code = domainPart.charCodeAt(i)
    if (code !== 46 && !isDomainChar(code)) return false
  }

  return true
}
